<template>
    <div class="questionnaire-container questionnaire-nps row col-sm-7 col-sm-offset-3 col-md-8 col-lg-4 col-md-offset-1 col-lg-offset-4">
        <div class="nps-question-title form-label col-sm-5 col-md-10 col-lg-10">
            <span>{{label}}</span>
        </div>
        <div class="nps-options form-label col-sm-5 col-md-10 col-lg-10">
          <div class="nps-option form-label"
            v-for="(item, index) in NPSOption"
            :key="index"
            @click="selectNpsScore(item)"
            >
            <span>{{item}}</span>
            <div class="nps-radio-box" :class="internalValue === item ? 'checked' : ''">
              <div v-show="internalValue === item" class="point"></div>
              <input type="radio" hidden='hidden' :value="item" name="NPS-option" v-model="internalValue"/>
            </div>
          </div>
        </div>
        <div v-if="notice" class="col-xs-12 col-sm-offset-5 col-md-offset-5 col-lg-offset-4 col-sm-7 col-md-7 col-lg-12 notice-text">{{ this.notice }}</div>
        <div v-if="errorMessage || internalErrorMessage" class="col-xs-12 col-sm-7 col-md-7 col-lg-12 error-text">{{ this.internalErrorMessage || this.errorMessage }}</div>
    </div>
</template>
<script>
import { questionnaireMixin } from './mixin.js'
import _ from 'lodash'

export default {

  mixins: [questionnaireMixin],
  props: ['label', 'isEditable', 'notice', 'placeholder', 'value', 'isRequired', 'errorMessage'],
  components: {
  },
  data () {
    return {
      internalErrorMessage: '',
      internalValue: null,
      NPSOption: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    }
  },
  model: {
    event: 'change'
  },
  created () {
  },
  watch: {
    '$i18n.locale' (val) {
      this.validate()
    },
    internalValue (val) {
      this.validate()
      this.$emit('change', val)
    },
    value: {
      handler (val, oldVal) {
        const npsValue = _.toInteger(val)
        if (this.NPSOption.includes(npsValue)) {
          this.internalValue = npsValue
        }
      },
      immediate: true
    }
  },
  methods: {
    validate () {
      if (this.fieldIsRequired(this.isRequired)) {
        if (!this.internalValue) {
          this.internalErrorMessage = this.$t('questionnaire.error.isRequired')
          return false
        }
      }
      this.internalErrorMessage = ''
      return true
    },
    selectNpsScore (score) {
      this.internalValue = score
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/questionnaire-common.scss';
.questionnaire-nps {
  margin-bottom: 1.2rem;
  display: flex;
  flex-direction: column;

  .nps-question-title {
    text-align: left;
    margin-bottom: -8px;
    justify-content: flex-start;
    word-break: break-all;
  }
  .nps-options {
    justify-content: space-between;

    .nps-option {
      display: flex;
      flex-direction: column;
      align-items: center;

      .checked {
        border-color: #0075ff;
      }

      .point {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #0075ff;
      }
    }

    .nps-radio-box {
      width: 16px;
      height: 16px;
      background-color: #FFFFFF;
      border: 1px solid #000000;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

}
</style>
